module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page",
    attrs: {
      "id": "contact"
    }
  }, [_c('navigation', {
    staticClass: "absolute"
  }), _vm._v(" "), _c('div', {
    staticClass: "shapes"
  }, [_vm._l((7), function(x) {
    return _c('div', {
      staticClass: "diamond"
    })
  }), _vm._v(" "), _vm._l((7), function(x) {
    return _c('div', {
      staticClass: "circle"
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "box"
    }, [(item.link) ? _c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": '/dist/' + item.icon
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.phone) ? _c('a', {
      attrs: {
        "href": 'tel:' + item.phone
      }
    }, [_vm._v(_vm._s(item.phone))]) : _c('h3', [_vm._v(_vm._s(item.subtitle))])]) : [_c('img', {
      attrs: {
        "src": '/dist/' + item.icon
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.phone) ? _c('a', {
      attrs: {
        "href": 'tel:' + item.phone
      }
    }, [_vm._v(_vm._s(item.phone))]) : _c('h3', [_vm._v(_vm._s(item.subtitle))])]], 2)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f158f84","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/contact.vue
// module id = 154
// module chunks = 0